module.exports = __webpack_public_path__ + "img/trash-can-solid.249f6c99.svg";